import { VenueHeadquarterDataViewModel } from "Services/API/API";
import React, { CSSProperties, useMemo } from "react";
import classes from "./styles.module.scss";
import { MapPinHQ } from "Components/Icons";

interface VenueCustomCtaProps {
   headquarterData: VenueHeadquarterDataViewModel;
}

const VenueCustomCta: React.FC<VenueCustomCtaProps> = ({ headquarterData }) => {

   const pinStyle = useMemo(() => {
      const pinStyle = {} as CSSProperties;

      if (headquarterData.hqPinColor) {
         pinStyle["--pin-color"] = headquarterData.hqPinColor;
      }
      if (headquarterData.hqPinColorHover) {
         pinStyle["--pin-color-hover"] = headquarterData.hqPinColorHover;
      }

      return pinStyle;
   }, [headquarterData]);

   return <div className={classes.wrapper}>
      <div className={classes.picture}>
         <svg width="144" height="75" viewBox="0 0 144 75" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_15432_60681)">
               <ellipse cx="72" cy="56.5" rx="72" ry="18.5" fill="url(#paint0_radial_15432_60681)" />
               <path d="M93.9339 42.3806L55.7092 63.7031L40.7688 72M53.0018 30.9958L115.051 48.0863C115.899 48.3197 116.868 48.4757 117.888 48.5429L140.001 49.9995M43.5026 38.9993L133.501 64.4997M118.501 70.4968L54.9085 51.8668C53.2313 51.3754 51.0813 51.2074 49.0538 51.4093L42.871 52.0249C41.5021 52.1612 40.2706 52.4583 39.3403 52.8768L13.5 64.4997M6.9998 48.4389L88.5014 73.4998" stroke="white" strokeWidth="2.31748" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <g opacity="0.4" filter="url(#filter0_f_15432_60681)">
               <ellipse cx="72" cy="57.5" rx="7" ry="1.5" fill="url(#paint1_radial_15432_60681)" />
            </g>
            <defs>
               <filter id="filter0_f_15432_60681" x="63" y="54" width="18" height="7" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                  <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur_15432_60681" />
               </filter>
               <radialGradient id="paint0_radial_15432_60681" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(72 56.5) rotate(0.41518) scale(69.0018 17.7296)">
                  <stop stopColor="#D8DCE0" />
                  <stop offset="1" stopColor="white" stopOpacity="0" />
               </radialGradient>
               <radialGradient id="paint1_radial_15432_60681" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(72 57.5) rotate(90) scale(1.5 7)">
                  <stop stopColor="#444444" />
                  <stop offset="1" stopColor="#001A2B" stopOpacity="0" />
               </radialGradient>
               <clipPath id="clip0_15432_60681">
                  <rect y="38" width="144" height="37" rx="18.5" fill="white" />
               </clipPath>
            </defs>
         </svg>
         <MapPinHQ
            className={classes.pin}
            iconText={headquarterData.hqPinLabel}
            logo={headquarterData.hqPinImage}
            width={42}
            height={48}
            style={pinStyle}
         />
      </div>
      <div className={classes.text}>
         Book at this {headquarterData.enterpriseAccountName} office through your <br/>company's internal booking software.
      </div>
      {
         headquarterData.customCTA
            ? <a href={headquarterData.customCTA.url} target="_blank" className={"btn btn-primary"}>
               {headquarterData.customCTA.text}
            </a>
            : null
      }

   </div>;
}

export default VenueCustomCta;